import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/Button';
import { useToast } from '../hooks/useToast';
import { PS, T } from '../lib/theme';

export function LoginPage() {
  const { firebaseUser, isAdmin, loading, signIn } = useAuth();
  const { push } = useToast();
  const [signingIn, setSigningIn] = useState(false);
  const location = useLocation();

  // Where to go after sign-in. Defaults to "/".
  const from = (location.state as { from?: { pathname: string } } | null)?.from?.pathname ?? '/';

  // Once auth resolves, this redirect kicks in and unmounts the page.
  if (!loading && firebaseUser && isAdmin) {
    return <Navigate to={from} replace />;
  }

  const onSignIn = async () => {
    setSigningIn(true);
    try {
      await signIn();
    } catch (err) {
      push('error', err instanceof Error ? err.message : 'Sign-in failed');
    } finally {
      setSigningIn(false);
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: PS.pageBg,
        padding: 16, // breathing room on narrow phones
      }}
    >
      <div
        style={{
          background: PS.white,
          padding: 32,
          borderRadius: 4,
          border: `1px solid ${PS.borderLight}`,
          width: '100%',
          maxWidth: 360,
          display: 'flex',
          flexDirection: 'column',
          gap: 16,
        }}
      >
        <h1 style={{ ...T.sectionTitle, margin: 0 }}>ProSpin Admin</h1>
        <p style={{ ...T.caption, margin: 0 }}>
          Sign in with the Google account that has been granted admin access.
        </p>
        <Button onClick={() => void onSignIn()} disabled={signingIn}>
          {signingIn ? 'Signing in…' : 'Sign in with Google'}
        </Button>
      </div>
    </div>
  );
}
